import { DriverInfoBlockProps } from "./DriverInfoBlock.types";

import styles from "./DriverInfoBlock.module.scss";

const DriverInfoBlock = ({
  title,
  children,
  ...props
}: DriverInfoBlockProps) => {
  return (
    <div className={styles.infoBlock} {...props}>
      <h3 className={styles.title}>{title}</h3>
      {children}
    </div>
  );
};

export default DriverInfoBlock;
